<!-- FLOW-346: rendered inside the Ops Applications page, which owns the page
     head and breadcrumb; this list shows only its count and filter chip. -->
<div>
  <div class="queue-toolbar">
    @if (!isLoading()) {
      <p class="queue-toolbar__count">
        {{ filteredApplications().length }} {{ stageFilterLabel() ? 'shown' : 'in queue' }}
      </p>
    }
    @if (stageFilterLabel(); as label) {
      <button class="queue-filter-chip" type="button" (click)="clearFilter()">
        <span>Filtered: {{ label }}</span>
        <app-icon name="x-circle" [size]="14" />
      </button>
    }
  </div>

  @if (isLoading()) {
    <mat-card appearance="outlined" class="table-card">
      <table class="queue-table sg-table--skeleton">
        <thead>
          <tr>
            <th>Business</th>
            <th>Amount</th>
            <th>AI recommendation</th>
            <th>Stage</th>
            <th>Submitted</th>
            <th>Assignee</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (r of skeletonRows; track r) {
            <tr>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w70"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w50"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text" style="width: 65%"></span></td>
              <td><span class="sg-skeleton sg-skeleton--chip"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text" style="width: 55%"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w60"></span></td>
              <td></td>
            </tr>
          }
        </tbody>
      </table>
    </mat-card>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load applications</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="reload()">
        <app-icon name="refresh" [size]="18" /> Try again
      </button>
    </div>
  } @else if (filteredApplications().length === 0) {
    <div class="sg-empty sg-empty--bordered">
      <app-icon name="document" [size]="40" />
      @if (stageFilterLabel(); as label) {
        <p class="sg-empty__title">No {{ label }} applications</p>
        <p class="sg-empty__desc">No applications match this filter right now.</p>
        <button mat-stroked-button type="button" (click)="clearFilter()">
          <app-icon name="restore" [size]="18" /> Clear filter
        </button>
      } @else {
        <p class="sg-empty__title">No applications yet</p>
        <p class="sg-empty__desc">
          Applications submitted to the Kickstart Cash queue will appear here.
        </p>
      }
    </div>
  } @else {
    <mat-card appearance="outlined" class="table-card">
      <table mat-table [dataSource]="pagedApplications()" class="queue-table">
        <ng-container matColumnDef="entity">
          <th mat-header-cell *matHeaderCellDef>Business</th>
          <td mat-cell *matCellDef="let app">{{ app.entity_name }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let app">{{ app.amount_requested | zar }}</td>
        </ng-container>

        <ng-container matColumnDef="ai_recommendation">
          <th mat-header-cell *matHeaderCellDef>AI recommendation</th>
          <td mat-cell *matCellDef="let app" class="ai-col">
            {{ aiRecLabel(app.latest_ai_recommendation) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef>Stage</th>
          <td mat-cell *matCellDef="let app">
            <app-status-chip [status]="app.application_stage" kind="ks-stage" />
          </td>
        </ng-container>

        <ng-container matColumnDef="submitted">
          <th mat-header-cell *matHeaderCellDef>Submitted</th>
          <td mat-cell *matCellDef="let app">
            {{ app.submitted_at | date: 'mediumDate' | dash }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assignee">
          <th mat-header-cell *matHeaderCellDef>Dealt with by</th>
          <td mat-cell *matCellDef="let app">
            @if (app.assignee_name) {
              {{ app.assignee_name }}
            } @else {
              <span class="queue-unassigned">Nobody</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef><span class="cdk-visually-hidden">Action</span></th>
          <!-- Stop propagation so the button does not also open the row. -->
          <td
            mat-cell
            *matCellDef="let app"
            class="queue-action"
            (click)="$event.stopPropagation()"
          >
            @if (canPickUp(app)) {
              <button
                class="queue-pickup-btn"
                type="button"
                [disabled]="pickingUp() === app.short_id"
                [attr.aria-label]="'Pick up ' + app.entity_name"
                (click)="pickUp(app)"
              >
                {{ pickingUp() === app.short_id ? 'Picking up…' : 'Pick up' }}
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr
          mat-row
          *matRowDef="let app; columns: columns"
          class="queue-table__row"
          [routerLink]="['/ops/kickstart', app.short_id]"
        ></tr>
      </table>

      @if (filteredApplications().length > pageSize()) {
        <mat-paginator
          [length]="filteredApplications().length"
          [pageSize]="pageSize()"
          [pageSizeOptions]="[25, 50, 100]"
          (page)="onPage($event)"
          aria-label="Select page"
        />
      }
    </mat-card>
  }
</div>
